import { render, staticRenderFns } from "./modalCopiarDe.vue?vue&type=template&id=79d945b6&"
import script from "./modalCopiarDe.vue?vue&type=script&lang=js&"
export * from "./modalCopiarDe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports